import { render } from "./GetAllResources.vue?vue&type=template&id=6ebb9f6a"
import script from "./GetAllResources.vue?vue&type=script&lang=js"
export * from "./GetAllResources.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__